import http from "../../http";
import { API_URLs } from "../../CONSTANTS";

const orders_apis = API_URLs.orders;

export const apiCall_getOrders = () => {
  return http.get(orders_apis.getOrders);
};

export const apiCall_seeOrder = (orderId) => {
  return http.post(orders_apis.seeOrder + "?reqId=" + orderId);
};

export const apiCall_sendOrder = (orderId) => {
  return http.post(orders_apis.sendOrder + "?reqId=" + orderId);
};

export const apiCall_finishOrder = (orderId) => {
  return http.post(orders_apis.finishOrder + "?reqId=" + orderId);
};

export const apiCall_orderDetails = (orderId) => {
  return http.post(orders_apis.getOrderDetails + "?reqId=" + orderId);
};
